import React from 'react';
import { useSiteContent } from '../context/SiteContentContext';
import { Award, Palette, Clock, Shield, Heart, Users, Zap, Settings } from 'lucide-react';

const iconMap = {
  Award, Palette, Clock, Shield, Heart, Users, Zap, Settings
};

const WhyChooseUs = () => {
  const { content } = useSiteContent();
  const items = content.why_items || [];

  if (!items.length) return null;

  return (
    <section id="zakaj" className="py-20 md:py-28 bg-[#2D4A5E]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-black text-white mb-4">
            {content.why_title?.split(' ').slice(0, 2).join(' ')} <span className="text-[#4CAF50]">{content.why_title?.split(' ').slice(2).join(' ')}</span>
          </h2>
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12">
          {items.map((item) => {
            const Icon = iconMap[item.icon] || Award;
            return (
              <div key={item.id} className="text-center group">
                <div className="mb-4 flex justify-center">
                  <div className="w-16 h-16 rounded-full bg-white/10 flex items-center justify-center group-hover:bg-white/20 transition-colors duration-300">
                    <Icon className="w-8 h-8 text-[#4CAF50]" />
                  </div>
                </div>
                <h3 className="text-white font-bold text-lg md:text-xl mb-3">
                  {item.title}
                </h3>
                <div className="w-8 h-0.5 bg-[#4CAF50] mx-auto mb-4"></div>
                <p className="text-white/70 text-sm leading-relaxed max-w-xs mx-auto">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
